<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Dqc8rj/tc-custom/9780226691909.jpg?1722568965411" alt="This image is the cover for the book Economic Other"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Economic Other
      </h1>
      <p class="bookDescription body article font2">
        <p>Economic inequality is at a record high in the United States, but public demand for redistribution is not rising with it. Meghan Condon and Amber Wichowsky show that this paradox and other mysteries about class and US politics can be solved through a focus on social comparison. Powerful currents compete to propel attention up or down—toward the rich or the poor—pulling politics along in the wake.<br/><br/> Through an astute blend of experiments, surveys, and descriptions people offer in their own words, <i>The Economic Other</i> reveals that when less-advantaged Americans compare with the rich, they become more accurate about their own status and want more from government. But American society is structured to prevent upward comparison. In an increasingly divided, anxious nation, opportunities to interact with the country’s richest are shrinking, and people prefer to compare to those below to feel secure. Even when comparison with the rich does occur, many lose confidence in their power to effect change. <br/><br/> Laying bare how social comparisons drive political attitudes, <i>The Economic Other</i> is an essential look at the stubborn plight of inequality and the measures needed to solve it.<br/>  </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Meghan Condon, Amber Wichowsky
      </h2>
      
      <p class="authorDescription body article"><B>Meghan Condon</B> is assistant professor in the Department of Political Science at Loyola University Chicago. <B>Amber Wichowsky</B> is associate professor in the Department of Political Science and director of the Marquette Democracy Lab at Marquette University.<br> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0c8f4d52